export default class Aprovador {

  constructor (
    id = 0,
    nome = '',
    registro = '',
    cargo = '',
  ) {
    this.id = id;
    this.nome = nome;
    this.registro = registro;
    this.cargo = cargo;
  }
}



// WEBPACK FOOTER //
// ./src/domain/ferias/aprovador.js